import addDays from 'date-fns/addDays';
import format from 'date-fns/format';
import startOfDay from 'date-fns/startOfDay';

type IntervalWithTimestamps = { from: number; to: number };

/**
 * Группирует интервалы по датам (yyyy-MM-dd).
 * Многодневный интервал попадает во все даты от начала до конца включительно.
 *
 * @kind helper
 * @typeParam T — тип элемента интервала (обязательно поля from, to;)
 * @param intervals — массив интервалов с полями from, to (Unix timestamp в секундах)
 * @returns Запись: ключ — дата (yyyy-MM-dd), значение — массив интервалов, затрагивающих эту дату
 */
export function groupIntervalsByDate<T extends IntervalWithTimestamps>(intervals: T[]): Record<string, T[]> {
    const acc: Record<string, T[]> = {};

    for (const interval of intervals) {
        const startDate = startOfDay(new Date(interval.from * 1000));
        const endDate = startOfDay(new Date(interval.to * 1000));

        let current = startDate;

        while (current.getTime() <= endDate.getTime()) {
            const dateKey = format(current, 'yyyy-MM-dd');

            acc[dateKey] = acc[dateKey] ?? [];
            acc[dateKey].push(interval);
            current = addDays(current, 1);
        }
    }

    return acc;
}
